const ReadOnlyLock = ({ locked }) => {
  return (
    <i className={locked ? 'fa fa-lock text-danger' : 'fa fa-unlock text-success'} style={{ fontSize: '.875rem' }}></i>
  );
};

export default ReadOnlyLock;
